module.exports = __webpack_public_path__ + "static/media/internal_env_2_media_2.88c343eb.webp";